import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTE_PATH } from '@/constants/routes';
import { useSuiteLoungeFlow } from '@/hooks/useSuiteLoungeFlow';

export const SignUpConfirmContainer = () => {
  const { t } = useTranslation();
  const { withEntry } = useSuiteLoungeFlow();
  const signUpPath = withEntry(ROUTE_PATH.SIGN_UP);

  return (
    <section className="l-card">
      <div className="l-card__body l-pt0">
        <div className="l-text-group l-text-group--white">
          <p className="l-text l-text--left l-text--spacing">
            {t('signupConfirm.description')}
          </p>
        </div>
        <div className="l-box l-box--account">
          <div
            className="l-box__lead"
            dangerouslySetInnerHTML={{
              __html: t('signupConfirm.bitkeyAccount.description'),
            }}
          />
          <div className="l-box__link">
            <a
              href={t('common.links.workhub.about')}
              target="_blank"
              rel="noopener noreferrer"
              className="l-box__link-text"
            >
              {t('signupConfirm.bitkeyAccount.linkText')}
            </a>
          </div>
          <div className="l-box__image">
            <img
              src="/Common_Related_Services02.png"
              alt="bitkeyサービス"
              className="l-box__image-img"
            />
          </div>
        </div>
        <div className="actions">
          <Link
            to={signUpPath}
            className="link-button link-button--next"
          >
            {t('common.btn.next')}
          </Link>
        </div>
      </div>
    </section>
  );
};
